// Re-export SharedVideoPlayer as GameStatsVideoPlayer for backwards compatibility
import SharedVideoPlayer from '../../../components/SharedVideoPlayer';

const GameStatsVideoPlayer = (props) => <SharedVideoPlayer {...props} />;

export default GameStatsVideoPlayer;
